import { FC, Suspense, useCallback } from 'react';
import { closeModal } from 'state/actions/modalActions';
import { useModalContext } from 'state/contexts/modalContext/modalContext';
import LoaderCircle from 'components/Common/LoaderCircle/LoaderCircle';
import { ModalType } from 'state/contexts/modalContext/types';
import Modal from './ModalParts/Modal';

import styles from './ModalRoot.module.scss';
import {
  ModalAllowance,
  ModalAuthenticate,
  ModalAuthenticateClient,
  ModalAuthenticateLedger,
  ModalAuthenticateSignature,
  ModalEditProfile,
  ModalFilesUpload,
  ModalMyDealLeaveReview,
  ModalEarlyAccess,
  ModalFilstationEarlyAccess,
  ModalConfirmFileDelete,
  ModalEditEmail,
  ModalStorageProviderEditPreview,
  ModalChangeEmailMessage,
  ModalStorageRequest,
  ModalCheckEmailMessage,
  ModalInitialFilecoinAddressConnect,
  ModalConnectedAddresses,
  ModalAccountSettings,
  ModalDeclineStorageRequest,
  ModalLoginRequired,
} from './modalMapping';

const ModalRoot: FC = () => {
  const { modal, dispatch } = useModalContext();

  const closeFunc = useCallback(() => {
    closeModal(dispatch);
  }, [dispatch]);

  const isModalOpen = modal.modalType !== ModalType.NO_MODAL;

  return (
    <Modal
      isModalOpen={isModalOpen}
      closeModal={closeFunc}
      width={modal.modalProps.width}
      newStyles={styles}
      className={modal.modalProps.className || '1111'}
    >
      <Suspense
        fallback={
          <div className={styles['modal-suspense-wrapper']}>
            <LoaderCircle />
          </div>
        }
      >
        {(() => {
          switch (modal.modalType) {
            case ModalType.MODAL_AUTHENTICATE_CLIENT:
              return <ModalAuthenticateClient {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_AUTHENTICATE:
              return <ModalAuthenticate {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_AUTHENTICATE_LEDGER:
              return <ModalAuthenticateLedger {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_AUTHENTICATE_SIGNATURE:
              return (
                <ModalAuthenticateSignature {...modal.modalProps} newStyles={styles} />
              );
            case ModalType.MODAL_ALLOWANCE:
              return <ModalAllowance {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_EDIT_PROFILE:
              return <ModalEditProfile {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_MY_DEAL_REVIEW_MESSAGE:
              return <ModalMyDealLeaveReview {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_EARLY_ACCESS:
              return <ModalEarlyAccess {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_FILSTATION_EARLY_ACCESS:
              return (
                <ModalFilstationEarlyAccess {...modal.modalProps} newStyles={styles} />
              );
            case ModalType.MODAL_CONFIRM_FILE_DELETE:
              return <ModalConfirmFileDelete {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_FILES_UPLOAD:
              return <ModalFilesUpload {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_EDIT_EMAIL:
              return <ModalEditEmail {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_STORAGE_PROVIDER_EDIT_PREVIEW:
              return (
                <ModalStorageProviderEditPreview
                  {...modal.modalProps}
                  newStyles={styles}
                />
              );
            case ModalType.MODAL_SP_HAS_EMAIL_POPUP:
              return <ModalChangeEmailMessage {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_STORAGE_REQUEST:
              return <ModalStorageRequest {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_CHECK_EMAIL_MESSAGE:
              return <ModalCheckEmailMessage {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_INITIAL_FILECOIN_ADDRESS_CONNECT:
              return (
                <ModalInitialFilecoinAddressConnect
                  {...modal.modalProps}
                  newStyles={styles}
                />
              );
            case ModalType.MODAL_CONNECTED_ADDRESSES:
              return <ModalConnectedAddresses {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_ACCOUNT_SETTINGS:
              return <ModalAccountSettings {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_LOGIN_REQUIRED:
              return <ModalLoginRequired {...modal.modalProps} newStyles={styles} />;
            case ModalType.MODAL_REJECT_STORAGE_REQUEST:
              return (
                <ModalDeclineStorageRequest {...modal.modalProps} newStyles={styles} />
              );
            case ModalType.NO_MODAL:
              return <></>;
          }
        })()}
      </Suspense>
    </Modal>
  );
};

export default ModalRoot;
